import React from 'react'
import PropTypes from 'prop-types'
import { Button, Copy } from '@elparking/components'
import CarFilter from '../Icons/CarFilter'
import Filters from '../Icons/Filters'

const FilterButton = ({ onClick, iconType, label, active }) => {
    return (
        <Button
          backgroundColor={active ? 'accent10' : 'white'}
          borderColor={active ? 'accent_dark70' : 'gray'}
          hoverBackgroundColor={active ? 'accent10' : 'white'}
          hoverBorderColor={active ? 'accent_dark70' : 'gray'}
          borderWidth='1px'
          height='auto'
          padding='8px 8px'
          mr='8px'
          onClick={onClick}
          textTransform='capitalize' >
            <Copy
              fontWeight='book'
              fontSize={['xSmall', 'small']}
              fontColor={active ? 'accent_dark70' : 'gray'}
              padding='0'
              textAlign='center'
              display='flex'>
                {iconType === 'car'
                  ? <CarFilter
                      size='xSmall'
                      color={active ? 'accent_dark70' : 'gray'}
                      type={iconType} />
                  : <Filters
                      size='xSmall'
                      color={active ? 'accent_dark70' : 'gray'}
                      type={iconType} />} {label}
            </Copy>
        </Button>

    )
}

FilterButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    iconType: PropTypes.oneOf(['car', 'filter']).isRequired,
    label: PropTypes.any.isRequired,
    active: PropTypes.bool,
}

export default FilterButton
